export default {"src":"/_next/static/media/icon-count-players.0ba2595f.svg","height":512,"width":512};